import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { BackButtonComponent } from 'src/app/shared/components';
import { CreditCardFormComponent } from 'src/app/shared/components/form-guest-credit-card/credit-card-form.component';
import { ImageLoaderComponent } from 'src/app/shared/components/image-loader/image-loader.component';
import { LastFourDigitsComponent } from 'src/app/shared/components/last-four-digits/last-four-digits.component';
import { CardTypeComponent } from 'src/app/shared/components/logo-credit-card/card-type.component';
import { ExpirationDateComponent } from '../expiration-date/expiration-date.component';
import { PaymentMethodItemService } from '../services/payment-methods.service';
import { CreditCardsMaterialModule } from './credit-cards-material-modules.module';
import { CreditCardsRoutingModule } from './credit-cards-routing.module';
import { CreditCardsComponent } from './credit-cards.component';
import { EmptyCardListComponent } from './empty-card-list/empty-card-list.component';
import { MethodCreditCardsService } from './services/method-credit-cards.service';

@NgModule({
    imports: [
        CommonModule,
        CreditCardsMaterialModule,
        CardTypeComponent,
        LastFourDigitsComponent,
        ExpirationDateComponent,
        ImageLoaderComponent,
        CreditCardFormComponent,
        EmptyCardListComponent,
        CreditCardsRoutingModule,
        BackButtonComponent,
    ],
    declarations: [CreditCardsComponent],
    exports: [CreditCardsComponent],
    providers: [MethodCreditCardsService, PaymentMethodItemService],
})
export class CreditCardsModule {}
